import { MijnRoute } from '../../mijn-navigatie.model';

export const SELF_SERVICE_REFUSED_PAYMENTS_VIEW: MijnRoute = {
    path: 'geweigerde-overboekingen/:id',
    navigationEvent: 'toGeweigerd',
    regex: /^\/zelf-regelen\/geweigerde-overboekingen\/[^/]+$/,
    webcomponent: 'mijn-transacties-geweigerd-webcomponent'
};
